var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-container"},[_c('div',{staticClass:"about-container-left"},[_c('pageNav',{attrs:{"active":1}})],1),_c('div',{staticClass:"about-container-right"},[_c('div',{staticClass:"about-container-right-describe",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }